/** Kobra IA — shell (sidebar, top bar, main) — alineado con Seguimiento / Inbox */
export const K = {
  navy: '#121826',
  blue: '#4185F1',
  green: '#6BD56F',
  border: 'rgba(18, 24, 38, 0.08)',
};

export const layoutPageBg = '#F8FAFC';
export const sidebarBg = '#FFFFFF';
export const drawerWidth = 240;
export const topBarHeight = 64;

/** Fondo tipo “pill” del ítem activo (mockup Kobra) */
export const navItemSelectedBg = '#E6F0FF';
export const navItemSelectedBgHover = '#D6E8FF';
